import { render, staticRenderFns } from "./AdministrarInstructivoEmbarqueModal.vue?vue&type=template&id=15115304"
import script from "./AdministrarInstructivoEmbarqueModal.vue?vue&type=script&lang=js"
export * from "./AdministrarInstructivoEmbarqueModal.vue?vue&type=script&lang=js"
import style0 from "./AdministrarInstructivoEmbarqueModal.vue?vue&type=style&index=0&id=15115304&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports